import React, { useCallback } from 'react';
import cn from 'classnames';

import IMG_SLICK from 'assets/images/logos/slick-logo-text.png';
import validateEmail from 'bl/validation/validateEmail.bl';
import Button from 'components/form/Button.component';
import FormField from 'components/form/FormField.component';
import TextInput from 'components/form/TextInput.component';
import S from 'constants/string.const';
import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';
import useTip from 'hooks/useTip.hook';
import { useTranslation } from 'providers/GILT.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import call from 'utils/functions/call.util';

import { normalizeEmail } from 'lib/normalize';

import CN from './EmailPanel.module.scss';

const EmailPanel = ({ tag: tagFromProps, onNext }) => {
  const { t } = useTranslation();
  const tag = fromAnyToTrimmed(tagFromProps);

  const [email, setEmail] = useStateWhileMounted(S.empty);

  const { inv: isNextDisabled, set: setIsEmailValid } = useTip(false);

  const handleValidate = useCallback(
    ({ trimmed }) => {
      const isValid = validateEmail({ value: trimmed });
      setIsEmailValid(isValid);
      setEmail(normalizeEmail(trimmed));
      return { error: isValid ? null : t('common.errors.validation.notValidEmail') };
    },
    [setEmail, setIsEmailValid, t],
  );

  const handleNext = useCallback(
    //
    () => void call('EmailPanel.onNext', onNext, { tag, email }),
    [email, onNext, tag],
  );

  const inputClasses = cn({
    [CN.inputContainer]: true,
    [CN.hasError]: isNextDisabled && fromAnyToTrimmed(email) !== '' && !validateEmail({ value: email }),
  });

  return (
    <div data-bem="EmailPanel" data-tag={tag} className={CN.component}>
      <img src={IMG_SLICK} alt="Slick logo" className={CN.logo} />
      <div className={CN.title}>
        {t('forgotPassword.title1.part1')} <span className={CN.bold}>{t('forgotPassword.title1.part2')}</span> {S.key}
      </div>
      <div className={CN.subTitle}>{t('forgotPassword.description1')}</div>
      <div className={inputClasses}>
        <FormField input={TextInput} name="email" label={t('forgotPassword.emailLabel')} placeholder={t('forgotPassword.emailPlaceholder')} onValidate={handleValidate} renderError="always" />
      </div>
      <div className={CN.buttonContainer}>
        <Button variant="primaryForce" width="max" height="max" onClick={handleNext} disabled={isNextDisabled}>
          <span className={CN.buttonFont}>{t('forgotPassword.sendCodeButton')}</span>
        </Button>
      </div>
    </div>
  );
};

export default EmailPanel;
